import type { FlowGraph, FlowTheme } from './types';

export const SCHEMA_VERSION = 1;

export const LIMITS = {
  MAX_NODES: 30,
  MAX_CHOICES: 4,
  MAX_EXITS: 10,
  LABEL_MAX: 60,
  PROMPT_MAX: 120,
  CHOICE_LABEL_MAX: 40,
  NAME_MAX: 80,
  URL_MAX: 2048,
  EXTRA_PARAMS_MAX: 10,
  EXTRA_KEY_MAX: 64,
  EXTRA_VALUE_MAX: 256,
  START_TEXT_MAX: 40,
  TIME_MAX: 86400,
} as const;

export const STRUCTURE = {
  UNKNOWN_FIELD: 'UNKNOWN_FIELD',
  INVALID_VALUE: 'INVALID_VALUE',
  TOO_LONG: 'TOO_LONG',
  LIMIT_EXCEEDED: 'LIMIT_EXCEEDED',
  DUPLICATE_ID: 'DUPLICATE_ID',
  INVALID_URL: 'INVALID_URL',
  PAUSE_WITHOUT_CHOICES: 'PAUSE_WITHOUT_CHOICES',
  PAUSE_WITHOUT_SHOW_AT: 'PAUSE_WITHOUT_SHOW_AT',
  PAUSE_BEFORE_SHOW_AT: 'PAUSE_BEFORE_SHOW_AT',
} as const;

export const PUBLISH = {
  START_NODE_MISSING: 'START_NODE_MISSING',
  NODE_WITHOUT_VIDEO: 'NODE_WITHOUT_VIDEO',
  VIDEO_NOT_IN_FLOW: 'VIDEO_NOT_IN_FLOW',
  VIDEO_NOT_READY: 'VIDEO_NOT_READY',
  CHOICE_TARGET_MISSING: 'CHOICE_TARGET_MISSING',
  EXIT_UNKNOWN: 'EXIT_UNKNOWN',
  CHOICE_LABEL_DUPLICATE: 'CHOICE_LABEL_DUPLICATE',
  CHOICE_LABEL_EMPTY: 'CHOICE_LABEL_EMPTY',
} as const;

export const WARNINGS = {
  NODE_UNREACHABLE: 'NODE_UNREACHABLE',
  NO_CHECKOUT_EXIT: 'NO_CHECKOUT_EXIT',
} as const;

export const ID_PATTERNS = {
  node: /^n_[A-Za-z0-9_-]{1,40}$/,
  choice: /^c_[A-Za-z0-9_-]{1,40}$/,
  exit: /^x_[A-Za-z0-9_-]{1,40}$/,
};

export const COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export const DEFAULT_THEME: FlowTheme = {
  aspect_ratio: 'auto',
  accent_color: '#0057FF',
  prompt_color: '#FFFFFF',
  choice_style: {
    bg_color: '#FFFFFF',
    text_color: '#111827',
    radius: 12,
    show_letter: true,
    position: 'bottom',
  },
  scrim_opacity: 0.35,
  border: { enabled: false, color: '#FFFFFF', width: 2, radius: 12 },
  progress: { type: 'fake', color: '#0057FF' },
  controls: 'none',
  start: {
    mode: 'muted_preview',
    text: 'Clique para ouvir',
    text_color: '#FFFFFF',
    bg_color: '#0057FF',
  },
};

export const emptyGraph = (): FlowGraph => ({ start_node_id: null, nodes: [], exits: [] });
export const defaultTheme = (): FlowTheme => JSON.parse(JSON.stringify(DEFAULT_THEME));
